@if (employees()) {
  <div class="flex h-full flex-col items-center justify-between gap-3">
    <div class="flex h-4/5 w-full flex-row gap-3">
      <div class="flex w-10 flex-col">
        <div
          class="vertical-text flex h-full items-center justify-center bg-neutral-98 p-2 font-bold">
          Potencial
        </div>
      </div>
      <div class="flex w-10 flex-col justify-between gap-3">
        <div
          class="vertical-text flex h-full items-center justify-center bg-green-100 px-2 py-5 text-sm font-medium">
          Alto
        </div>
        <div
          class="vertical-text flex h-full items-center justify-center bg-orange-100 px-2 py-5 text-sm font-medium">
          Medio
        </div>
        <div
          class="vertical-text flex h-full items-center justify-center bg-red-100 px-2 py-5 text-sm font-medium">
          Bajo
        </div>
      </div>
      <div class="flex h-full flex-1 flex-col justify-between gap-3">
        <div class="flex h-full w-full justify-between gap-3">
          <qaroni-matrix-nine-grid-box
            message="Potencial alto / Desempeño bajo"
            class="flex-1"
            [employees]="employeesHighPotentialLowPerformance" />
          <qaroni-matrix-nine-grid-box
            message="Potencial alto / Desempeño medio"
            class="flex-1"
            [employees]="employeesHighPotentialMediumPerformance" />
          <qaroni-matrix-nine-grid-box
            message="Potencial alto / Desempeño Alto"
            class="flex-1"
            [employees]="employeesHighPotentialHighPerformance" />
        </div>
        <div class="flex h-full w-full justify-between gap-3">
          <qaroni-matrix-nine-grid-box
            message="Potencial Medio / Desempeño bajo"
            class="flex-1"
            [employees]="employeesMediumPotentialLowPerformance" />
          <qaroni-matrix-nine-grid-box
            message="Potencial Medio / Desempeño medio"
            class="flex-1"
            [employees]="employeesMediumPotentialMediumPerformance" />
          <qaroni-matrix-nine-grid-box
            message="Potencial Medio / Desempeño alto"
            class="flex-1"
            [employees]="employeesMediumPotentialHighPerformance" />
        </div>
        <div class="flex h-full w-full justify-between gap-3">
          <qaroni-matrix-nine-grid-box
            message="Potencial Bajo / Desempeño Bajo"
            class="flex-1"
            [employees]="employeesLowPotentialLowPerformance" />
          <qaroni-matrix-nine-grid-box
            message="Potencial Bajo / Desempeño Medio"
            class="flex-1"
            [employees]="employeesLowPotentialMediumPerformance" />
          <qaroni-matrix-nine-grid-box
            message="Potencial Bajo / Desempeño alto"
            count="3"
            class="flex-1"
            [employees]="employeesLowPotentialHighPerformance" />
        </div>
      </div>
    </div>
    <div class="flex h-1/5 w-full gap-3">
      <div class="w-10 min-w-10"></div>
      <div class="w-10 min-w-10"></div>
      <div class="flex flex-1 flex-col gap-3">
        <div class="flex gap-3">
          <div
            class="flex min-w-[117px] flex-1 shrink-0 items-center justify-center bg-red-100 py-2 text-sm font-medium">
            Bajo
          </div>
          <div
            class="flex min-w-[117px] flex-1 shrink-0 items-center justify-center bg-orange-100 py-2 text-sm font-medium">
            Medio
          </div>
          <div
            class="flex min-w-[117px] flex-1 shrink-0 items-center justify-center bg-green-100 py-2 text-sm font-medium">
            Alto
          </div>
        </div>
        <div
          class="flex h-fit shrink-0 items-center justify-center bg-neutral-98 p-2 text-sm font-bold">
          Desempeño
        </div>
      </div>
    </div>
  </div>
}
